import React from 'react';
import { useSpaceVisual } from './hooks/useSpaceVisual';
import SpaceVisualTabs from './components/SpaceVisualTabs';

const SpaceVisual: React.FC = () => {
  const {
    activeTab,
    setActiveTab,
    selectedFloor,
    setSelectedFloor,
    handleRefresh,
    handleFullscreen,
    handleSettings
  } = useSpaceVisual();

  return (
    <SpaceVisualTabs
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      selectedFloor={selectedFloor}
      setSelectedFloor={setSelectedFloor}
      handleRefresh={handleRefresh}
      handleFullscreen={handleFullscreen}
      handleSettings={handleSettings}
    />
  );
};

export default SpaceVisual;
